import React from "react";
import type { Breakpoint } from "@/types/shared.types";

type CustomBreakpoint = Breakpoint | "smaller";

const getBreakpoint = (
  width: number,
  withCustomBreakpoints = false,
): CustomBreakpoint => {
  if (width < 600) return "xs";
  if (withCustomBreakpoints && width <= 640) return "smaller";
  if (width < 900) return "sm";
  if (width < 1200) return "md";
  if (width < 1536) return "lg";
  return "xl";
};

type UseBreakpointOptions = {
  withCustomBreakpoints?: boolean;
};

const useBreakpoint = (options?: UseBreakpointOptions) => {
  const customBreakpoints = options?.withCustomBreakpoints ?? false;

  const [label, setLabel] = React.useState<ReturnType<typeof getBreakpoint>>(
    () => getBreakpoint(900, customBreakpoints),
  );

  React.useEffect(() => {
    const handleWindowResize = () => {
      const newLabel = getBreakpoint(window.innerWidth, customBreakpoints);
      setLabel((prev) => (prev !== newLabel ? newLabel : prev));
    };
    handleWindowResize();
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, [customBreakpoints]);

  return label;
};

export default useBreakpoint;
